﻿/// <reference path="../../../Scripts/TypeScript/angularjs/angular.d.ts"/>

namespace Umbrella.TaskHandling {
    angular.module('TaskHandling').config([
        '$stateProvider',
        $stateProvider => {
            $stateProvider.state('dashboard.tasks.overview.edit', {
                url:
                    '/edit/{id:(?:[a-fA-F0-9]{8}(?:-[a-fA-F0-9]{4}){3}-[a-fA-F0-9]{12})}',
                reloadOnSearch: false,
                data: {
                    pageTitle: 'Taak bewerken',
                    authorize: p => p.editTask
                },
                views: {
                    'details@dashboard.tasks': {
                        template:
                            '<edit-task state="state$ | async:this"></edit-task>',
                        controller: Umbrella.createComponentRouteController<
                            Overview.State,
                            EditTaskComponentState
                        >('TaskOverviewStore', s => ({
                            task:
                                s &&
                                s.selectedTask &&
                                JSON.parse(JSON.stringify(s.selectedTask))
                        }))
                    }
                }
            });
        }
    ]);
}
